export enum OnlineBookingStep {
    AddPet = 'add_pet',
    SelectPets = 'select_pets',
    SelectServices = 'select_services',
    SelectStaff = 'select_staff',
    SelectDateTime = 'select_date_time',
    NotesAndAgreements = 'notes_and_agreements',
    Checkout = 'check_out'
}

export const OnlineBookingStepNames = {
    [OnlineBookingStep.AddPet]: 'Add Pet',
    [OnlineBookingStep.SelectPets]: 'Select Pets',
    [OnlineBookingStep.SelectServices]: 'Select Services',
    [OnlineBookingStep.SelectStaff]: 'Select Staff',
    [OnlineBookingStep.SelectDateTime]: 'Select Date & Time',
    [OnlineBookingStep.NotesAndAgreements]: 'Notes & Agreements',
    [OnlineBookingStep.Checkout]: 'Checkout'
};
